import DatePickerWeekly from "../components/DatePickerWeekly";
import { Link } from "react-router-dom";
import Modal from "react-modal";

export default function SelectDayModal({
  showDModal,
  handleCloseDModal,
  handleToday,
  setSelectedDate,
  setSelectedDateLabel,
  setShowDModal,
  setShowModal,
  handlePreviousWeek,
  handleNextWeek,
  week,
}) {
  return (
    <Modal
      isOpen={showDModal}
      onRequestClose={handleCloseDModal}
      contentLabel="Date Picker Modal"
      className="modal"
      overlayClassName="overlay"
    >
      <div className="modal-header">
        <h2>چه روزی باشه؟</h2>
        <Link to="" onClick={handleCloseDModal}>
          <span className="icon-iconclose b-white heading-1"></span>
        </Link>
      </div>

      <div className="modal-body">
        <div className="leftAlign padding3 marginBottom3 width30 leftSide">
          <a onClick={handleToday} className="purple-1">
            برو به امروز
          </a>
        </div>

        <DatePickerWeekly
          week={week}
          setSelectedDate={setSelectedDate}
          setSelectedDateLabel={setSelectedDateLabel}
          setShowDModal={setShowDModal}
          setShowModal={setShowModal}
          className="modal-body"
        ></DatePickerWeekly>

        <a onClick={handlePreviousWeek}>
          <span className="icon-iconchevron-right pWeekIndex purple-1 b-grey-5 side heading-1"></span>
        </a>

        <a onClick={handleNextWeek}>
          <span className="icon-iconchevron-left nWeekIndex purple-1 b-grey-5 side heading-1"></span>
        </a>
      </div>
    </Modal>
  );
}
